const steps = [
  {
    icon: 'ri-search-eye-line',
    title: '第一步 · 搜',
    desc: '按网红、主播、艺人或事件关键词检索，历史黑料一键直达。',
  },
  {
    icon: 'ri-file-history-line',
    title: '第二步 · 查',
    desc: '看整档汇总与时间线，每条标注出处与更新时间，留痕可对线。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '第三步 · 跟',
    desc: '收藏人物开启跟更，新瓜、反转、后续声明一个都不漏。',
  },
];

export default function GuideCta() {
  return (
    <section id="guide" className="w-full border-y border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 max-w-2xl">
          <p className="text-xs font-semibold tracking-[0.2em] text-primary-600">HOW TO · 使用说明</p>
          <h3 className="mt-1 font-heading text-xl font-black text-foreground-950 md:text-2xl">
            扒哥黑料档案，三步上手
          </h3>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {steps.map((s, i) => (
            <div
              key={i}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h4 className="mt-4 text-base font-bold text-foreground-950">{s.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* 下载横幅 */}
        <div id="download" className="mt-8 overflow-hidden rounded-lg bg-primary-600">
          <div className="flex flex-col gap-6 px-6 py-8 md:flex-row md:items-center md:justify-between md:px-10 md:py-10">
            <div className="max-w-xl">
              <div className="inline-flex items-center gap-2 rounded-full bg-primary-700/70 px-3 py-1 text-xs font-medium text-accent-100">
                <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
                吃瓜不迷路
              </div>
              <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                把扒哥黑料资料库装进口袋，
                <br className="hidden sm:block" />
                快讯更新、历史备查随身走。
              </h3>
            </div>

            <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-apple-fill text-lg" aria-hidden="true"></i>
                iOS 版下载
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-accent-500/90 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-400"
              >
                <i className="ri-android-fill text-lg" aria-hidden="true"></i>
                Android 版下载
              </a>
            </div>
          </div>
          <p className="bg-primary-950/10 px-6 py-2.5 text-xs text-background-50/80 md:px-10">
            扒哥黑料仅按公开网络信息整理归档备查，事件以官方通报与平台处理为准；App 端为演示入口，未开放真实下载。
          </p>
        </div>
      </div>
    </section>
  );
}